import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20geometric%20background%20with%20soft%20golden%20and%20cream%20gradients%2C%20minimalist%20modern%20design%2C%20flowing%20organic%20shapes%2C%20clean%20atmosphere%2C%20subtle%20texture%2C%20no%20text%2C%20elegant%20and%20calm&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-transparent"></div>

      <div className="relative z-10 container-custom text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/50 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-foreground-700 font-medium">已收录 25+ 个入口链接 · 实时更新</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-6 max-w-3xl mx-auto leading-tight">
          爱情岛论坛导航
        </h1>
        <p className="text-base md:text-lg text-background-200 mb-8 max-w-2xl mx-auto leading-relaxed">
          为您汇聚最新、最全的爱情岛论坛入口链接，提供一站式导航服务。<br className="hidden sm:block" />
          快速找到官方地址、备用线路及相关社区资源，<strong>收藏本页永不迷路</strong>。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/official-entry"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-link text-lg"></i>
            查看官方入口
          </Link>
          <Link
            to="/category/backup-links"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/90 text-foreground-800 rounded-lg font-medium hover:bg-background-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-router-line text-lg"></i>
            备用线路
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 flex-wrap">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-background-50">25+</div>
            <div className="text-xs text-background-300 mt-1">导航入口</div>
          </div>
          <div className="w-px h-10 bg-background-300/30"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-background-50">6</div>
            <div className="text-xs text-background-300 mt-1">分类覆盖</div>
          </div>
          <div className="w-px h-10 bg-background-300/30"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-background-50">99.9%</div>
            <div className="text-xs text-background-300 mt-1">可用率保障</div>
          </div>
        </div>
      </div>
    </section>
  );
}